import { default as WJElement } from '../wje-element/element.js';
import CardSubtitle from './card-subtitle.element.js';

// export * from "./card-subtitle.element.js";
export default CardSubtitle;

WJElement.define('wje-card-subtitle', CardSubtitle);
